var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',[_c('v-btn',{on:{"click":_vm.scheduleNotification}},[_vm._v("Schedule Notification")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }